enum StandingOrderEventType {
  StandingOrderCancelRequested = 'StandingOrderCancelRequested',
  StandingOrderCancelled = 'StandingOrderCancelled',
}

/**
 * Payload shape measured on dev (the frame also carries the STO schedule,
 * effective dates, and audit fields; only what the frontend consumes is
 * declared here).
 */
type StandingOrderEventDetail = {
  standingOrderUUID: string;
  passengerUUID: string;
  clientBC: string;
  state: string;
};

export { StandingOrderEventType, type StandingOrderEventDetail };
